import { CLIENTPORTAL_CAPABILITY_V2 } from './clientportal-capability-contract'
import { CLIENTPORTAL_SCREEN_V2 } from './clientportal-screen-contract'
import { serializeJsonV2 } from './serialize-json-v2'
import { CLIENTPORTAL_THEME_CONTRACT_V2 } from './theme-contracts'
import type { ExperienceKitV2 } from 'sdui-core'

export const CLIENTPORTAL_WEB_KIT_V2 = {
  contractVersion: 2,
  artifact: 'experience-kit',
  product: 'clientportal',
  platform: 'web',
  theme: CLIENTPORTAL_THEME_CONTRACT_V2,
  screens: CLIENTPORTAL_SCREEN_V2,
  capabilities: CLIENTPORTAL_CAPABILITY_V2,
} satisfies ExperienceKitV2

export const serializeClientPortalWebKitV2 = () => serializeJsonV2(CLIENTPORTAL_WEB_KIT_V2)
